DomainNameCheckService.$inject = [];

/**
 * @ngdoc  service
 * @module webStoreAdmin
 * @name   webStoreAdmin.service:DomainNameCheck
 * @description
 * Utility service to verify the domain name format
 */
/* @ngInject */ export function DomainNameCheckService() {
  /** 
   * Regular expression for domain name checking. This supports letters, numbers,
   * and hyphens and must start with an alpha character. 
   */
  const REG_EX_DOMAIN = /^[a-z]([a-z0-9\-]*[a-z0-9])?$/;
  /**
   * @ngdoc    method
   * @name     check
   * @methodOf webStoreAdmin.service:DomainNameCheck
   * @param    {String}  name     Domain name to check.
   * @param    {Boolean} required Indication the domain name is required
   * @return   {String}           Error message when invalid. Null=Valid
   * @description
   * Checks that the provided name matches the validation pattern. An error
   * message is returned when invalid. Null=Valid input.
   ***************************************************************************/
  this.check = function (name, required) {
    if (!name && required) return 'Domain name is required';

    if (name && !REG_EX_DOMAIN.test(name))
      return 'Domain Name must begin with a letter and may contain only letters, numbers and hyhens(-).';

    return null;
  };
}
